<template>
  <b-form @submit.prevent="onSubmit">
    <b-input-group class="search-input">
      <b-form-input placeholder="Search" v-model="text"></b-form-input>
      <b-input-group-append>
        <b-button variant="primary" type="submit">
          <span class="material-icons p-0">
            search
          </span>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      text: '',
    };
  },
  methods: {
    onSubmit() {
      this.$emit('onSearch', { text: this.text });
    },
  },
};
</script>
<style lang="scss">
.search-container {
  min-width: 250px;
  max-width: 748px;
  margin: auto;
  .search-input {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 6px;

    input {
      border: none;
    }
  }
  .btn {
    line-height: 1;
  }
}
</style>
